
import { useStore } from "@/store";
import { Plus } from "@vicons/fa";
import { defineComponent } from "vue";

export default defineComponent({
	components: {
		Plus,
	},
	setup: () => {
		const store = useStore();
		return {
			onAddClicked() {
				store.dispatch("addDiary");
			},
		};
	},
});
